import React, { useEffect, useRef, useState } from "react";

// Animates a number from 0 to `to` when it scrolls into view.
// Supports decimals, thousands separators, and a prefix/suffix.
export default function CountUp({
  to,
  decimals = 0,
  duration = 2000,
  separator = false,
  prefix = "",
  suffix = "",
}) {
  const ref = useRef(null);
  const [value, setValue] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const run = () => {
      if (started.current) return;
      started.current = true;
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        // easeOutCubic for a smooth deceleration
        const eased = 1 - Math.pow(1 - p, 3);
        setValue(to * eased);
        if (p < 1) requestAnimationFrame(tick);
        else setValue(to);
      };
      requestAnimationFrame(tick);
    };

    const io = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { run(); io.unobserve(el); } },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [to, duration]);

  const rounded = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
  const display = separator
    ? Number(rounded).toLocaleString("en-GB", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })
    : rounded;

  return (
    <span ref={ref}>{prefix}{display}{suffix}</span>
  );
}
